module.exports = __webpack_public_path__ + "img/up_arrow_icon.f45c0511.svg";